namespace $ {

	$mol_style_define( $shm_agent_message_card, {
		flex: { direction: 'column', shrink: 0 },
		gap: $mol_gap.text,
		padding: { left: $mol_gap.block, right: $mol_gap.block, top: $mol_gap.text, bottom: $mol_gap.block },
		border: { radius: $mol_gap.round },
		background: { color: $mol_theme.card },
		'@': {
			role: {
				systemEvent: {
					background: { color: $mol_theme.hover },
					border: { style: 'solid', width: '1px', color: $mol_theme.line },
				},
			},
		},
		Head: {
			color: $mol_theme.shade,
			font: { size: '0.8rem' },
			gap: $mol_gap.text,
			align: { items: 'center' },
		},
		Header_extra: {
			display: 'contents',
		},
		Copy: {
			width: '2rem',
			height: '2rem',
			minWidth: '2rem',
			minHeight: '2rem',
			padding: 0,
			flex: { shrink: 0 },
			align: { items: 'center' },
			justifyContent: 'center',
		},
		Copy_icon: {
			width: '1rem',
			height: '1rem',
			flex: { shrink: 0 },
		},
		Time: {
			margin: { left: 'auto' },
		},
		Content: {
			flex: { direction: 'column', shrink: 0 },
			gap: $mol_gap.text,
			minHeight: 0,
			minWidth: 0,
			width: '100%',
		},
	} )

}
